import React from "react";
import { compose } from "redux";
import draggable from "fantastic/components/hoc/draggable";
import connectActions from "fantastic/lib/connectActions";
import Column from "./Column";

export default compose(draggable("SECTION"))(Column);
